import { useState, useEffect } from 'react';
import { Tabs, TabDesign, Breakpoints, useBreakpoint } from '@nextgen-web-framework/all';
import ShopByBrands from '../ShopByBrands/ShopByBrands';
import ImagesAndLinksContainer from '../ImagesAndLinksContainer/ImagesAndLinksContainer';
import styles from './ShopByContainer.module.scss';
import type { ShopByContainerProps } from './types/propsTypes';
const ShopByContainer = (props: ShopByContainerProps) => {
  const [activeTab, setActiveTab] = useState(props.activeTab);
  const viewport = useBreakpoint() as Breakpoints;

  const Pills = props.navigations
    ?.filter((pill) => pill.viewport?.includes(viewport) ?? true)
    .map((pill) => ({
      title: pill.title,
      id: pill.menuId,
    }));

  useEffect(() => {
    if (!props.activeTab) {
      Pills.length && setActiveTab(Pills[0]?.id);
    } else {
      setActiveTab(props.activeTab);
    }
  }, [props.activeTab]);

  const renderSelectedCategory = (): React.ReactNode => {
    const category = props.navigations.find((category) => (activeTab === category.menuId ? category : null));
    switch (category?.menuType) {
      case 'images_only':
        return <ShopByBrands categories={category.categories} allTitle={category.allTitle} />;
      case 'images_and_links':
        return <ImagesAndLinksContainer categories={category.categories} allTitle={category.allTitle} />;
      default:
        return <></>;
    }
  };

  const onTabClick = (tabIndex: number) => {
    setActiveTab(Pills[tabIndex]?.id);
    props.onTabClick?.(Pills[tabIndex]?.id);
  };

  return (
    <>
      <div
        className={`${styles['shop-by-page-navigator']} shop-by-navigator-positions hide-scrollbar`}
        data-testid={'shop-by-page-container-testid'}
      >
        {!props.hideNavigation && Pills.length > 0 && (
          <div className={`${styles['shop-by-navigator-container']}`}>
            <Tabs
              design={TabDesign.PILL}
              onTabClick={(tabIndex: number) => onTabClick(tabIndex)}
              selectedTab={props.selectedTab}
              tabList={Pills}
            />
          </div>
        )}
      </div>
      <div className={styles['shop-by-page-container']}>{renderSelectedCategory()}</div>
    </>
  );
};
export default ShopByContainer;

export type { ShopByContainerProps };
